import { Search } from "lucide-react";
import { cn } from "../../lib/cn.js";

/**
 * Generic filter bar for list views. Search input + slot for filter controls
 * + action slot (e.g. "New" button).
 *
 *   <FilterBar
 *     search={search}
 *     onSearchChange={setSearch}
 *     filters={<><Select ... /><Select ... /></>}
 *     actions={<Button>New design</Button>}
 *   />
 */
export function FilterBar({
  search = "",
  onSearchChange,
  searchPlaceholder = "Search…",
  filters,
  actions,
  className,
}) {
  return (
    <div
      className={cn(
        "flex flex-col gap-3 border-b border-border-subtle bg-bg-elevated p-4 lg:flex-row lg:items-center lg:justify-between",
        className
      )}
    >
      <div className="flex flex-1 flex-col gap-3 sm:flex-row sm:items-center">
        {onSearchChange && (
          <div className="relative w-full sm:max-w-xs">
            <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-text-muted" />
            <input
              type="search"
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder={searchPlaceholder}
              className="w-full rounded-md border border-border bg-bg-elevated-2 py-2 pl-9 pr-3 text-sm text-text-primary placeholder:text-text-muted focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent"
            />
          </div>
        )}
        {filters && <div className="flex flex-wrap items-center gap-2">{filters}</div>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
